<template>
  <footer class="footer">
    <div class="footer__wrapper">
      <MenuList :links="links" :modificatorClass="'menu--footer'" />
      <SocialList :socialBtns="socialBtns" />
    </div>
  </footer>
</template>

<script>
import MenuList from '~/components/MenuList.vue'
import SocialList from '~/components/SocialList.vue'

export default {
  name: 'TheFooter',
  components: {
    MenuList,
    SocialList
  },
  computed: {
    links() {
      return this.messages.global.header.nav
    },
    socialBtns() {
      return this.messages.global.footer.socialBtn
    }
  }
}
</script>

<style lang="scss">
.footer {
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    top: -10px;
    left: -60%;
    width: 1327px;
    height: 544px;
    background: url('/img/footer-bg-shape@mb.svg') no-repeat center;
    background-size: cover;
  }

  &__wrapper {
    @include container;

    padding: 74px 16px 74px;

    .menu__link {
      color: #282830;
    }
  }
}

@include media-min($tablet-width) {
  .footer {
    &::before {
      @include horizontal-center;

      top: -20px;
    }

    &__wrapper {
      display: flex;
      padding: 74px 25px 46px;
    }
  }
}

@include media-min($desktop-width) {
  .footer {
    &::before {
      top: initial;
      bottom: -533px;
      left: 50%;
      width: 1849px;
      height: 757px;
      background: url('/img/footer-bg-shape@dt.svg') no-repeat center;
      background-size: cover;
      transform: translateX(-50%);
    }

    &__wrapper {
      display: flex;
      padding: 145px 60px 55px;
    }
  }
}

@include media-min($monoblock-width) {
  .footer {
    &::before {
      bottom: -435px;
      width: 2582px;
      height: 669px;
      background: url('/img/footer-bg-shape@mn.svg') no-repeat center;
      background-size: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/TheFooter/TheFooter.vue